const SCOPE = 'investigation'

export const investigationKeys = {
  all: () => [{ scope: SCOPE }] as const,
  search: (creditApplicationId: string) => [{ scope: SCOPE, entity: 'search', creditApplicationId }] as const,
  traces: (creditApplicationId: string) => [{ scope: SCOPE, entity: 'traces', creditApplicationId }] as const,
  orchestrations: (creditApplicationId: string, instanceIds: string[]) =>
    [{ scope: SCOPE, entity: 'orchestrations', creditApplicationId, instanceIds: instanceIds.join(',') }] as const,
}
